import React from 'react';

import './Sentiment.css';

const Sentiment = props => {

    function millisToMinutesAndSeconds(millis) {
        var minutes = Math.floor(millis / 60000);
        var seconds = ((millis % 60000) / 1000).toFixed(0);
        return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
    }

    
    const clickHandler = () => {
        props.onClick(props.start);
    };

    if (props.sentiment === 'NEUTRAL') {
        return (<div className='neutral'><button onClick={clickHandler}><p>{props.text+"["+millisToMinutesAndSeconds(props.start)+"-"+millisToMinutesAndSeconds(props.end)+"]"}</p></button></div>);
    }
    else if (props.sentiment === 'POSITIVE') {
        return (<div className='positive' style={{ backgroundColor: `rgba(80, 255, 80, ${props.confidence})` }}><button onClick={clickHandler}><p>{props.text+"["+millisToMinutesAndSeconds(props.start)+"-"+millisToMinutesAndSeconds(props.end)+"]"}</p></button></div>);
    }
    else {
        return (<div className='negative' style={{ backgroundColor: `rgba(255, 80, 80, ${props.confidence})` }}><button onClick={clickHandler}><p>{props.text+"["+millisToMinutesAndSeconds(props.start)+"-"+millisToMinutesAndSeconds(props.end)+"]"}</p></button></div>);
    }
};

export default Sentiment;